import * as React from 'react';
import { Path } from 'react-native-svg';
import { Icon, IIconProps } from 'native-base';

const SvgCreditCard = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Path d="M18.125 3.125H1.875a.624.624 0 00-.625.625v12.5c0 .346.28.625.625.625h16.25c.346 0 .625-.28.625-.625V3.75a.624.624 0 00-.625-.625zM2.656 4.531h14.688v2.344H2.656V4.531zM17.344 15.47H2.656V8.594h14.688v6.875zm-4.63-1.25h3.223c.086 0 .157-.07.157-.156v-1.407a.157.157 0 00-.157-.156h-3.222a.157.157 0 00-.156.156v1.406c0 .086.07.157.156.157z" />
    </Icon>
  );
};

export default SvgCreditCard;
